// extracted by mini-css-extract-plugin
module.exports = {"section":"why-integrate_section__3TH6e","carousel":"why-integrate_carousel__3iypP","item":"why-integrate_item__22AqG","utilities":"why-integrate_utilities__4pOkm"};